/**
 * Слова о связи внутри продажи и на входе (RP-SALE-FAST, шаги 5 и 7б). Тексты связи живут только в модели здоровья
 * (`krp/connection-text`): экраны берут готовые строки отсюда, а не пишут свои.
 */

/** «Отменить» нажато, связи нет: команда ждёт в очереди источника и уйдёт сама, как только связь появится. */
export const CANCEL_QUEUED_TEXT = 'Отмена поставлена в очередь: отправим, как только появится связь.'

/** Подпись кнопки «проверить сервер сейчас» в строке связи. */
export const LINK_RETRY_LABEL = 'Повторить сейчас'

/** Название строки связи для диктора и подсказки. */
export const LINK_STRIP_LABEL = 'Связь с сервером'

/** Возраст данных: «обновлено 7 с назад» (промежуток — `formatSpan`). */
export const dataAgeText = (span: string): string => `обновлено ${span} назад`

/**
 * Нет связи, пока сервер проверяется сам: «Нет связи 12 с · попытка 3». Возраст данных, если он уже заметен, дописывается через « · ».
 */
export const linkDownText = (span: string, attempt: number, age: string | null): string =>
  ['Нет связи ' + span, `попытка ${Math.max(1, attempt)}`, ...(age === null ? [] : [age])].join(' · ')

/** Нет сети на устройстве: «Нет интернета на этом устройстве · без связи 12 с». Попытки — когда программа уже проверяет сервер сама. */
export const linkOfflineText = (span: string, attempt: number, age: string | null): string =>
  ['Нет интернета на этом устройстве', 'без связи ' + span, ...(attempt > 0 ? [`попытка ${attempt}`] : []), ...(age === null ? [] : [age])].join(' · ')

/** Сервер ответил на всё, что было, но давно: запрос завис, итога ещё нет. */
export const linkStaleText = (age: string): string => `Сервер долго не отвечает · ${age}`

/** Окно «Восстанавливаем соединение», нет сети на устройстве: сколько уже нет связи и что делать. */
export const offlineWindowText = (span: string): string =>
  `Нет интернета на этом устройстве (без связи ${span}). Проверьте Wi-Fi или кабель — программа проверяет сервер сама и продолжит работу, когда сеть появится.`

/** Вход не открылся: сервер входа не ответил. Программа повторяет проверку сама; число попыток — когда они уже были. */
export const gateRetryText = (attempts: number): string =>
  attempts === 0 ? 'Программа проверит сервер снова сама.' : `Программа проверяет сервер сама · попыток: ${attempts}.`
